<template>
  <div>
    <assign :titleHightlight="name"
      :title="'的考卷'"
      :assigned="assigned"
      v-on:selected="getSelected"
      v-on:remove="remove"
      v-on:assign="assign"
      v-on:back="() => { this.$router.push('/exam-mgr') }"
      v-on:finish="() => { this.$router.push('/exam-mgr') }" v-if="assigned !== null" />
  </div>
</template>

<script>
import Assign from './Assign'
import api from '../../store/api'
import swal from 'bootstrap-sweetalert'

export default {

  name: 'TeachingExamAssign',

  components: {
    Assign
  },

  data () {
    return {
      name: '',
      examId: null,
      assigned: null,
      pageIndex: 1,
      pageCount: 0
    }
  },

  created () {
    this.examId = this.$route.params.examId
    this.getAssigned()
  },

  async mounted () {
    if (this.examId) {
      const { data } = await api.get('/ExamMgr/TeachingExams/' + this.examId)

      if (data.status === 'OK') {
        this.name = data.data.name
      }
    }
  },

  methods: {
    async getAssigned (page) {
      let params = {
        pageIndex: page || this.pageIndex,
        pageSize: 10
      }

      const { data } = await api.get('ExamMgr/TeachingExams/' + this.examId + '/Groups', { params: params })

      if (data.status === 'OK') {
        this.assigned = data.data || []
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async assign (id) {
      let formData = new window.FormData()
      formData.append('groupIds', [id])

      const { data } = await api.post('ExamMgr/TeachingExams/' + this.examId + '/Groups', formData)

      if (data.status === 'OK') {
        console.log('assign complete', data)
      }
    },

    remove (id) {
      let self = this
      swal({
        title: '確定要刪除？',
        text: '注意！此動作無法回覆。',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: '沒錯，我要刪除',
        cancelButtonText: '取消',
        closeOnConfirm: false
      },
      async function () {
        let formData = new window.FormData()
        formData.append('groupIds', [id])
        formData = {
          data: formData
        }

        const { data } = await api.delete('ExamMgr/TeachingExams/' + self.examId + '/Groups', formData)

        if (data.status === 'OK') {
          swal('刪除成功!', '已取消指派.', 'success')
          console.log('delete complete', data)
        }
      })
    },

    getSelected (selected) {
      this.selected = selected
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TeachingExamAssign.vue?0438e49c